import { createAction, props } from '@ngrx/store';
import { MaintenanceNote, NoteAttachment, Vehicle } from '@fc-core';

export const loadMaintenanceNotes = createAction(
  '[MaintenanceNote] Load MaintenanceNotes',
  props<{ vehicle: Vehicle }>(),
);
export const loadMaintenanceNotesSuccess = createAction(
  '[MaintenanceNote] Load MaintenanceNotes Success',
  props<{ notes: MaintenanceNote[] }>(),
);
export const addMaintenanceNote = createAction(
  '[MaintenanceNote] Add MaintenanceNotes',
  props<{ note: MaintenanceNote }>(),
);
export const addMaintenanceNoteSuccess = createAction(
  '[MaintenanceNote] Add MaintenanceNotes Success',
  props<{ note: MaintenanceNote }>(),
);

export const updateMaintenanceNote = createAction(
  '[MaintenanceNote] Update MaintenanceNotes',
  props<{ note: MaintenanceNote }>(),
);
export const updateMaintenanceNoteSuccess = createAction(
  '[MaintenanceNote] Update MaintenanceNotes Success',
  props<{ note: MaintenanceNote }>(),
);

export const deleteMaintenanceNote = createAction(
  '[MaintenanceNote] Delete MaintenanceNotes',
  props<{ note: MaintenanceNote }>(),
);
export const deleteMaintenanceNoteSuccess = createAction(
  '[MaintenanceNote] Delete MaintenanceNotes Success',
  props<{ note: MaintenanceNote }>(),
);

export const deleteMaintenanceNoteAttachment = createAction(
  '[MaintenanceNote] Delete MaintenanceNote Attachment',
  props<{ note: MaintenanceNote; file: NoteAttachment }>(),
);
export const deleteMaintenanceNoteAttachmentSuccess = createAction(
  '[MaintenanceNote] Delete MaintenanceNote Attachment Success',
  props<{ note: MaintenanceNote; file: NoteAttachment }>(),
);

export const deleteMaintenanceNoteAttachments = createAction(
  '[MaintenanceNote] Delete MaintenanceNote Attachments',
  props<{ note: MaintenanceNote; files: NoteAttachment[] }>(),
);
export const deleteMaintenanceNoteAttachmentsSuccess = createAction(
  '[MaintenanceNote] Delete MaintenanceNote Attachments Success',
  props<{ note: MaintenanceNote; files: NoteAttachment[] }>(),
);

export const maintenanceNotesError = createAction(
  '[MaintenanceNote] MaintenanceNotes Error',
  props<{ err: any }>(),
);
